var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content order-grid" },
      [
        _c(
          "search-item",
          {
            key: _vm.identify,
            ref: _vm.identify,
            attrs: {
              "show-more-scheme": true,
              "show-simple": _vm.showSimple,
              "expand-adv": false,
              "search-item-code": _vm.searchItemCode,
              "config-module": _vm.configModule,
              "auto-init": _vm.searchItemAutoInit,
              "custom-search-items": _vm.customSearchItems,
              "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
              "is-append-query": _vm.isAppendQuery,
              "col-settings": _vm.colSettings
            },
            on: {
              advSearchItemCallBack: _vm.fetchData,
              simSearchItemCallBack: _vm.fetchDataBykeyWord
            }
          },
          [
            _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
            _c(
              "template",
              { slot: "searchAreaHeader" },
              [_vm._t("searchAreaHeader")],
              2
            )
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": _vm.gridConfigModule,
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "pagination-wrapper",
            attrs: { id: "footer-wrapper-order-grid" }
          },
          [
            _c("cargo-pagination", {
              ref: "paginationOrderGrid",
              attrs: {
                "config-module": _vm.gridConfigModule,
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.fetchDataByPage
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }